import { useMemo } from 'react'
import * as styles from './styles'

type ProgressWheelProps = {
  className?: string
  /**
   * Value must be between 0 and 1
   */
  progress?: number
  size: number
  strokeWidth: number
}

export const ProgressWheel = ({
  className,
  progress = 0,
  size,
  strokeWidth,
}: ProgressWheelProps) => {
  const { outerRadius, progressRadius, circumf } = useMemo(() => {
    const outer = size / 2

    return {
      innerRadius: outer - strokeWidth,
      outerRadius: outer,
      progressRadius: (size - strokeWidth) / 2,
      circumf: (size - strokeWidth) * Math.PI,
    }
  }, [size, strokeWidth])

  const strokeProgression = useMemo(() => {
    if (!progress) return circumf
    return circumf - progress * circumf
  }, [circumf, progress])

  return (
    <span
      className={className}
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemax={1}
    >
      <svg
        aria-hidden={true}
        className={styles.selectors.root}
        height={size}
        width={size}
        strokeWidth={strokeWidth}
      >
        <circle
          className={styles.selectors.ring}
          css={styles.ring}
          cx={outerRadius}
          cy={outerRadius}
          r={progressRadius}
        />
        <circle
          className={styles.selectors.progressStroke}
          css={[styles.ring, styles.progressStroke]}
          cx={outerRadius}
          cy={outerRadius}
          r={progressRadius}
          strokeDasharray={`${circumf}, ${circumf}`}
          strokeDashoffset={strokeProgression}
          strokeWidth={strokeWidth}
        />
      </svg>
    </span>
  )
}
ProgressWheel.displayName = 'Lapidary: ProgressWheel'
